import { Component, Input } from '@angular/core';
import {
  faCircleExclamation,
  faCircleInfo,
} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'canvas-form-field',
  templateUrl: './form-field.component.html',
  styleUrl: './form-field.component.scss',
  standalone: false,
})
export class FormFieldComponent {
  @Input() label = '';
  @Input() unitOfMeasure = '';
  @Input() required = false;
  @Input() hasError: boolean | null | undefined = false;
  @Input() hideExclamationIcon = false;
  @Input() removeExclamationIcon = false;
  @Input() adjustErrorIcon = false;
  @Input() disabled = false;
  @Input() tooltip: string | null = null;

  faCircleInfo = faCircleInfo;
  faCircleExclamation = faCircleExclamation;
}
